export interface CohortCreateState {
    ui: { loading: boolean }
}

export const initialCohortCreateState: CohortCreateState = {
    ui: { loading: false }
}
